import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Star } from 'lucide-react';
import { mockSuppliers } from '../../data/mockData';

export function TopSuppliers() {
  // Sort suppliers by quality score and take top 5
  const topSuppliers = [...mockSuppliers]
    .filter((s) => s.status === 'active')
    .sort((a, b) => b.qualityScore - a.qualityScore)
    .slice(0, 5);

  // Generate initials and gradient colors for supplier logos
  const getSupplierInitials = (name: string) => {
    return name
      .split(' ')
      .map((word) => word[0])
      .join('')
      .substring(0, 2)
      .toUpperCase();
  };

  const gradients = [
    'from-violet-500 to-indigo-500',
    'from-cyan-500 to-blue-500',
    'from-emerald-500 to-green-500',
    'from-amber-500 to-orange-500',
    'from-rose-500 to-pink-500',
  ];

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-lg font-semibold">Top Suppliers</CardTitle>
        <Button
          variant="ghost"
          size="sm"
          className="text-xs text-muted-foreground"
        >
          View All
        </Button>
      </CardHeader>
      <CardContent className="space-y-2">
        {topSuppliers.map((supplier, index) => (
          <div
            key={supplier.id}
            className="flex items-center gap-3 p-3 rounded-xl border border-transparent hover:border-violet-500/30 hover:bg-muted/50 transition-all duration-200 cursor-pointer"
          >
            {/* Supplier Logo */}
            <div
              className={`w-11 h-11 rounded-xl bg-gradient-to-br ${gradients[index % gradients.length]} flex items-center justify-center text-white font-bold text-sm`}
            >
              {getSupplierInitials(supplier.name)}
            </div>

            {/* Supplier Info */}
            <div className="flex-1 min-w-0">
              <h4 className="font-semibold text-sm truncate">
                {supplier.name}
              </h4>
              <p className="text-xs text-muted-foreground truncate">
                {supplier.itemsSupplied.length > 0
                  ? `${supplier.itemsSupplied.length} products supplied`
                  : supplier.location}
              </p>
            </div>

            {/* Supplier Meta */}
            <div className="text-right">
              <div className="flex items-center gap-1 text-amber-500 font-semibold text-sm">
                <Star className="h-3.5 w-3.5 fill-current" />
                {(supplier.qualityScore / 20).toFixed(1)}
              </div>
              <p className="text-[10px] text-muted-foreground">
                {supplier.totalOrders} orders
              </p>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
